/* eslint-disable camelcase */
import { useCallback, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import isValidPayload from '@/tracker/isValidPayload';
import track from '@/tracker';
import type { processInfoType } from '../authorization/useClient/useClient';

export type payloadType = {
  actor?: {
    user_id?: string;
    type?: string;
    role?: string;
  };
  verb?: string;
  object?: {
    component?: string;
    process_info?: processInfoType;
    params?: {
      full_name?: string;
      degree_of_relatedness?: string;
      other_degree_of_relatedness?: string;
      marital_status?: string;
      maritage_regime?: string;
      email?: string;
      phone_numer?: string;
      birthdate?: string;
      nationality?: string;
      birthplace?: string;
      zipcode?: string;
      state?: string;
      city?: string;
      neighborhood?: string;
      address?: string;
      residence_type?: string;
      address_complement?: string;
      residential_number?: number;
      proof_of_residency_document_url?: string;
      cpf?: string;
      cpf_document_url?: string;
      rg?: string;
      rg_issuing_body?: string;
      rg_issuing_state?: string;
      rg_document_url?: string;
      document_selfie_url?: string;
      pep_check?: boolean;
      selection_process_id?: string;
    };
    path?: string;
    url?: string;
  };
  method?: string;
  context?: {
    source?: string;
  };
};

type useLazyTrackType = {
  (type: string, payload: payloadType, method: string): void;
};

function useLazyTrack({ trackRepeatedEvents = false } = {}): useLazyTrackType {
  const latestTrackedTypeRef = useRef('');
  const latestTrackedPayloadRef = useRef<payloadType>({});
  const latestTrackedMethodRef = useRef('');

  return useCallback(
    (type, payload, method) => {
      const repeated =
        type === latestTrackedTypeRef.current &&
        isEqual(payload, latestTrackedPayloadRef.current);

      if (repeated && !trackRepeatedEvents) return;

      if (!isValidPayload(payload)) return;

      latestTrackedTypeRef.current = type;
      latestTrackedPayloadRef.current = payload;
      latestTrackedMethodRef.current = method;

      track({ type, payload, method });
    },
    [trackRepeatedEvents],
  );
}

export default useLazyTrack;
